// src/components/CortesiaModal.tsx
import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { registerOpenCortesia } from "../../modalBridge";

const PHONE = "5579998782516";
const DEFAULT_MSG = "Olá! Meu período de cortesia expirou e preciso de ajuda.";

const buildWaLink = (phone: string, text = "") =>
  `https://wa.me/${phone.replace(/\D/g, "")}${
    text ? `?text=${encodeURIComponent(text)}` : ""
  }`;

const CortesiaModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [expiresAt, setExpiresAt] = useState<string>();

  useEffect(() => {
    registerOpenCortesia(({ expiresAt } = {}) => {
      setExpiresAt(expiresAt);
      setOpen(true);
    });
  }, []);

  const waUrl = buildWaLink(PHONE, DEFAULT_MSG);

  return (
    <Modal
      size="lg"
      isOpen={open}
      backdrop="static"
      keyboard={false}
      centered
      // sem toggle para não fechar clicando no X
    >
      <ModalHeader>Período de cortesia expirado</ModalHeader>
      <ModalBody>
        Seu período de cortesia expirou {expiresAt ? `em ${expiresAt}` : ""}.
        Para continuar utilizando nossos serviços, fale com o suporte.
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          tag="a"
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Falar com o suporte no WhatsApp
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CortesiaModal;
